import { render, staticRenderFns } from "./zoneSideMenu.vue?vue&type=template&id=4faf380b&scoped=true"
import script from "./zoneSideMenu.vue?vue&type=script&lang=js"
export * from "./zoneSideMenu.vue?vue&type=script&lang=js"
import style0 from "./zoneSideMenu.vue?vue&type=style&index=0&id=4faf380b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf380b",
  null
  
)

export default component.exports